import formatMoney from "../../../../../formatMoney";

export function getOtherValues(object) {
  let result = {
    net: 0,
    vat: 0,
  };
  const gross = parseFloat(object?.gross) || 0;
  const vatExempt = parseFloat(object?.vatExempt) || 0;
  const dedductedGross = gross - vatExempt;

  const vatRate = 0.12;

  let net = 0;
  let vat = 0;

  if (dedductedGross > 0) {
    net = dedductedGross / (1 + vatRate);
    vat = dedductedGross - net;
  }

  result.net = formatMoney(net);
  result.vat = formatMoney(vat);
  return result;
}

export function parseFormattedNumber(formattedStr) {
  if (typeof formattedStr !== "string") return NaN;
  const cleaned = formattedStr.replace(/,/g, "");
  return parseFloat(cleaned);
}

export function calculateNetAndVat(object, isVatable) {
  const gross = parseFloat(object?.gross) || 0;
  const vatExempt = parseFloat(object?.vatExempt) || 0;
  const zeroRated = parseFloat(object?.zeroRated) || 0;
  const dedductedGross = gross - vatExempt - zeroRated;

  const vatRate = 0.12;

  let net = 0;
  let vat = 0;

  if (dedductedGross > 0) {
    net = dedductedGross / (1 + vatRate);
    vat = dedductedGross - net;
  }

  if (isVatable) {
    return { net: formatMoney(net), vat: formatMoney(vat) };
  }

  return { net: formatMoney(gross), vat: formatMoney(0) };
}
